var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowing)?_c('div',{ref:"interactElement",staticClass:"card swipeable-card",class:{
    isAnimating: _vm.isInteractAnimating,
    isCurrent: _vm.isCurrent,
    odd: _vm.isCurrent && _vm.currentIndex % 2 === 1, 
    even: _vm.isCurrent && _vm.currentIndex % 2 === 0, 
  },style:({ transform: _vm.transformString })},[(_vm.index < 6)?_c('img',{staticClass:"card-image",attrs:{"src":_vm.index < 2? _vm.getAssetLink(_vm.card.relative_path): _vm.getImageThumb(_vm.card)}}):_vm._e(),_c('h3',{staticClass:"cardTitle"},[_vm._v("\n    "+_vm._s(_vm.card.caption)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }